// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"Uxz8s","showMoreButton":"kAJg0"};